<template>
	<!-- prettier-ignore -->
	<span class="whitespace-nowrap"><span v-if="prefix" class="mr-[0.3em]">{{ prefix }}</span>{{ value }}<span v-if="affix" :class="['ml-[0.3em]', affixClass]">{{ affix }}</span></span>
</template>

<script lang="ts" setup>
export interface Props {
  value?: number | string | null
  prefix?: string
  affix?: string
  affixClass?: string
}

withDefaults(defineProps<Props>(), { affixClass: 'text-[0.7em] font-normal' });
</script>
